import { OBJECTIVES, VARIABLES_POLITICA } from "../constants/Gamification";
// Función principal para calcular puntos gamificados
    // Función principal para calcular puntos gamificados
export const calcularPuntosGamificadosconst  =  (pacientes = 0, prestaciones = 0, citas = 0, transacciones = 0) => {
  
  let puntos = 0;

  // Puntos por acción
  puntos += pacientes * OBJECTIVES.PACIENTES.points;
  puntos += prestaciones * OBJECTIVES.PRESTACIONES.points;
  puntos += citas * OBJECTIVES.CITAS.points;
  puntos += transacciones * OBJECTIVES.TRANSACCIONES.points;
  

  return puntos;
}

export const calcularDescuentoEquivalente = (puntos) => {
  if (puntos >= VARIABLES_POLITICA.PUNTAJE_MAXIMO) {
    return VARIABLES_POLITICA.DESCUENTO_POR_PUNTAJE_COMPLETO;
  } else if (puntos >= VARIABLES_POLITICA.PUNTAJE_MINIMO)
    {
    // Por cada 500 otorgamos 10 soles de descuento, hasta 1500 puntos (30 soles), solo se otorga puntos si supera multiplos de 500
    // Ejemplo: 500 = 10, 999 = 10, 1000 = 20 , 1499 = 20, 1500 = 30
    // Lógica: 10 + Math.floor((puntos - 500) / 500) * 10
    // Si es 500, factor = 0, si es 1000, factor = 1, si es 1500, factor = 2    
    const factor = Math.floor((puntos - VARIABLES_POLITICA.PUNTAJE_MINIMO) / 500);
    return VARIABLES_POLITICA.DESCUENTO_POR_PUNTAJE_MINIMO + (factor * 10);

    
  } else {
    return 0; // No hay descuento
  }
}
